<template>
  <div class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive">
    <div class="card email-body radius-left">
      <div class="pl-0">
        <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:100vh;overflow:hidden;' : ''">
          <div class="tab-content">
            <div class="tab-pane fade" v-bind:class="'active show'">
              <div class="card mb-0">
                <div class="card-header d-flex customStickyCardHeader">
                  <h6 class="mb-0" style="align-self: center">
                    {{ indexName ? indexName : $t("lbl_EMPBE_AddNewCatelog") }}
                  </h6>
                  <div :style="fromAdmin ? '' : 'margin-right: 130px'">
                    <span class="" v-if="!isNew">
                      {{ $t("lbl_EMPBE_LastUpdate") }}:{{ lastUpdateDate }}<br />
                      {{ $t("lbl_EMPBE_LastSubmit") }}:{{ lastSubmitDate }}<br />
                      <!-- {{ $t("lbl_EMPBE_LastThreeMonthUpdateCount") }}:
                      {{ lastThreeMonthSubmitCount }} -->
                    </span>
                  </div>
                </div>
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                  <div class="card-body pb-0">
                    <div class="ribbon ribbon-bookmark ribbon-right ribbon-success customRibbon"
                      v-if="lastSubmitDate != '-' && !fromAdmin">
                      {{ $t("lbl_EMPBE_isActivate") }}
                    </div>
                    <div class="ribbon ribbon-bookmark ribbon-right ribbon-secondary customRibbon"
                      v-if="lastSubmitDate == '-' && !fromAdmin">
                      {{ $t("lbl_EMPBE_Draft") }}
                    </div>

                    <div class="row" v-if="false">
                      <div class="col-6">
                        <switchIput :title="$t('lbl_EMPBE_ActivateIndex')" data-item="isLaunch"
                          v-model="indexDetails.isLaunch">
                        </switchIput>
                      </div>
                    </div>
                    <div class="row" v-if="false">
                      <div class="col">
                        <textbox :title="$t('lbl_EMPBE_IndexName')" v-model="indexDetails.name"></textbox>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-12">
                        <h6>
                          {{ $t("lbl_EMPBE_IndexPhotoDesc") }}
                        </h6>
                      </div>
                      <div class="col">
                        <imageUpload componentId="imgIndexBanner" :aspectRatioselected="0.7045" ref="imgIndexBanner"
                          :imageArray="imgArr">
                        </imageUpload>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="row col-12">
                        <div class="col-12">
                          <h6>
                            {{ $t("lbl_EMPBE_IndexFileDesc").replace("#count#", count) }}
                          </h6>
                        </div>

                        <div class="col-md-4 form-group">
                          <h6>{{ $t("lbl_EMPBE_Simp") }}</h6>
                          <div style="display: none">
                            {{ isPdfSC }}{{ isPdfTC }}{{ isPdfEN }}
                          </div>
                          <textbox :placeholder="$t('lbl_EMPBE_IndexSimpName')" v-model="indexPdfDetails.nameSC"
                            :mandatory="isPdfSC
                              ? $t('lbl_EMPBE_IndexSimpName') + $t('lbl_IsRequire')
                              : null
                              ">
                          </textbox>
                          <!-- <input v-show="!isPdfSC" class="form-control" type="file" accept="application/pdf"
                          ref="catalogPdfSC" /> -->
                          <b-form-file v-show="!isPdfSC" class="mb-2" accept="application/pdf" ref="catalogPdfSC"
                            :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')" v-model="PdfSC"
                            :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')" :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')
                              " :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')" id="PDFSC"
                            @change="handleFileChange('isPdfSC')"></b-form-file>

                          <div v-show="isPdfSC" class="m-b-15 file-pdf">
                            <div class="file-top">
                              <i class="fa fa-file-pdf-o txt-primary"></i>
                            </div>
                            <div class="file-bottom">
                              <a target="_blank" :href="indexPdfDetails.pdfSC" v-if="indexPdfDetails.pdfSC"><button type="button"
                                  class="btn br-right btn-outline-primary">
                                  {{ $t("lbl_EMPBE_Check") }}
                                </button></a><button type="button" class="btn f-right br-right btn-outline-danger" @click="{isPdfSC = false;PdfSC=null;indexPdfDetails.pdfSC?indexPdfDetails.pdfSC=null:''; }">
                                {{ $t("Lbl_Clear") }}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 form-group">
                          <h6>{{ $t("lbl_EMPBE_TradChi") }}</h6>
                          <textbox :placeholder="$t('lbl_EMPBE_IndexTradName')" v-model="indexPdfDetails.nameTC"
                            :mandatory="isPdfTC
                              ? $t('lbl_EMPBE_IndexTradName') + $t('lbl_IsRequire')
                              : null
                              ">
                          </textbox>
                          <!-- <input v-show="!isPdfTC" class="form-control" type="file" accept="application/pdf"
                          ref="catalogPdfTC" /> -->
                          <b-form-file v-show="!isPdfTC" class="mb-2" accept="application/pdf" ref="catalogPdfTC"
                            :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')" v-model="PdfTC"
                            :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')" :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')
                              " :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')" id="PDFTC"
                            @change="handleFileChange('isPdfTC')"></b-form-file>
                          <div v-show="isPdfTC" class="m-b-15 file-pdf">
                            <div class="file-top">
                              <i class="fa fa-file-pdf-o txt-primary"></i>
                            </div>
                            <div class="file-bottom">
                              <a target="_blank" :href="indexPdfDetails.pdfTC" v-if="indexPdfDetails.pdfTC"><button type="button"
                                  class="btn br-right btn-outline-primary">
                                  {{ $t("lbl_EMPBE_Check") }}
                                </button></a><button type="button" class="btn f-right br-right btn-outline-danger" @click="{isPdfTC = false;PdfTC=null;indexPdfDetails.pdfTC?indexPdfDetails.pdfTC=null:'';}">
                                {{ $t("Lbl_Clear") }}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 form-group">
                          <h6>{{ $t("lbl_EMPBE_Eng") }}</h6>
                          <textbox :placeholder="$t('lbl_EMPBE_IndexEngName')" v-model="indexPdfDetails.nameEN"
                            CharLimit="CheckEnglishChar" :mandatory="isPdfEN
                              ? $t('lbl_EMPBE_IndexEngName') + $t('lbl_IsRequire')
                              : null
                              ">
                          </textbox>
                          <!-- <input v-show="!isPdfEN" class="form-control" type="file" accept="application/pdf"
                          ref="catalogPdfEN" /> -->
                          <b-form-file v-show="!isPdfEN" class="mb-2" accept="application/pdf" ref="catalogPdfEN"
                            :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')" v-model="PdfEN"
                            :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')" :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')
                              " :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')" id="PDFEN"
                            @change="handleFileChange('isPdfEN')"></b-form-file>
                          <div v-show="isPdfEN" class="m-b-15 file-pdf">
                            <div class="file-top">
                              <i class="fa fa-file-pdf-o txt-primary"></i>
                            </div>
                            <div class="file-bottom">
                              <a target="_blank" :href="indexPdfDetails.pdfEN" v-if="indexPdfDetails.pdfEN"><button type="button"
                                  class="btn br-right btn-outline-primary">
                                  {{ $t("lbl_EMPBE_Check") }}
                                </button></a>
                                <button type="button" class="btn f-right br-right btn-outline-danger" @click="{isPdfEN = false;PdfEN=null;}indexPdfDetails.pdfEN?indexPdfDetails.pdfEN=null:'';">
                                {{ $t("Lbl_Clear") }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="customizer-formbutton" v-if="$route.params.id">
                      <b-button-group>
                        <button class="btn btn-light btn-lg" @click="deleteIndexDetail" v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_' + catalogId + '_btnDelete'
                          ">
                          <i class="fa fa-trash-o m-r-5"></i>{{ $t("lbl_EMPBE_Delete") }}
                        </button>
                        <b-dropdown :text="$t('lbl_EMPBE_PreviewPage')" size="lg" variant="primary" v-if="false">
                          <b-dropdown-item>
                            <i class="icofont icofont-monitor m-r-5"></i>{{ $t("lbl_EMPBE_PC") }}
                          </b-dropdown-item>
                          <b-dropdown-item>
                            <i class="icofont icofont-android-tablet m-r-5"></i>{{ $t("lbl_EMPBE_Mobile") }}
                          </b-dropdown-item>
                        </b-dropdown>
                        <!-- <button class="btn btn-outline-primary btn-lg" @click="closeIndexDetail"
                        v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_' + catalogId + '_btnCancel'">
                        <i class="icofont icofont-undo m-r-5"></i>{{ $t("lbl_cancel") }}
                      </button> -->
                        <button class="btn btn-primary btn-lg" @click="todoSave" v-if="lastSubmitDate == '-'"
                          v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_' + catalogId + '_btnSave'
                            ">
                          <i class="fa fa-save m-r-5"></i>{{ $t("lbl_EMPBE_Save") }}
                        </button>
                        <button class="btn btn-success btn-lg" @click="todoSubmit" v-bind:t_label="'EMPBE_ProductInfoCenter_Catalog_' + catalogId + '_btnSubmit'
                          ">
                          <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_Submit") }}
                        </button>
                      </b-button-group>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>
<script>
import { productService } from "@/_services/product.service";
import { fileUploadService } from "../../_services";
import { isTransformerResult } from "@progress/kendo-data-query/dist/npm/transducers";

export default {
  components: {},
  inject: ["permissionData"],
  props: ["supplierId", "IndexId", "fromAdmin"],
  data() {
    return {
      test: "",
      dirty: false,
      count: 0,
      saveupdatedDate: "-",
      lastSubmitDate: "-",
      lastThreeMonthSubmitCount: "-",
      loading: false,
      isNew: true,
      isActivate: false,
      selectedActivate: false,
      indexName: "",
      docNameSimp: "",
      docNameTrad: "",
      docNameEng: "",
      indexDetails: {},
      indexPdfDetails: {
        nameSC: "",
        pdfSC: "",
        nameTC: "",
        pdfTC: "",
        nameEN: "",
        pdfEN: "",
      },
      isPdfSC: false,
      isPdfTC: false,
      isPdfEN: false,
      PdfSC: null,
      PdfTC: null,
      PdfEN: null,
      imgArr: [],
      files: [
        {
          EmpCompanyId: 0,
          UsageType: "ExhibitCatalog_Cover",
          FileName: "",
          componentId: "imgIndexBanner",
          LangId: null,
        },
        {
          EmpCompanyId: 0,
          UsageType: "ExhibitCatalog_Pdf",
          FileName: "",
          componentId: "catalogPdfSC",
          LangId: 936,
        },
        {
          EmpCompanyId: 0,
          UsageType: "ExhibitCatalog_Pdf",
          FileName: "",
          componentId: "catalogPdfTC",
          LangId: 950,
        },
        {
          EmpCompanyId: 0,
          UsageType: "ExhibitCatalog_Pdf",
          FileName: "",
          componentId: "catalogPdfEN",
          LangId: 1252,
        },
      ],
    };
  },
  mounted() { },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    catalogId() {
      return this.$route.params.id ? this.$route.params.id : this.IndexId;
    },
    companyid() {
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? this.user.empCompanyId
        : this.supplierId;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  watch: {
    "$route.params": {
      handler() {
        this.refresh();
      },
    },
    permissionData: {
      handler() {
        this.initPermissionData();
      },
      deep: true,
    },
    indexDetails: {
      handler() {
        this.dirty = true;
        this.$store.state.dirty = this.dirty;
        console.log("产品 cata dirty");
        console.log(this.$store.state.dirty);
      },
      deep: true,
    },
    dirty: {
      handler() {
        this.$store.state.dirty = this.dirty;
      },
    },
    indexPdfDetails: {
      handler() {
        this.dirty = true;
      },
      deep: true,
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.initData();
      this.initPermissionData();
    },
    initPermissionData() {
      this.count =
        this.permissionData != null ? (this.permissionData["Type"] == "A" ? 10 : 5) : 0;
    },
    handleFileChange(dataProperty) {
      // console.log('Selected file:',event);
      var selectedFile = event.target.files[0];
      if (selectedFile) {
        this[dataProperty] = true;
      } else {
        this[dataProperty] = false;
      }
    },
    initData() {
      var id = this.$route.params.id ? this.$route.params.id : this.IndexId;
      this.imgArr = [];
      this.indexPdfDetails = {};
      this.loading = true;
      if (id > 0) {
        setTimeout(() => {
          var parms = { type: "ProductCatalog", id: this.catalogId };
          productService.GetOtherInfo(parms).then((res) => {
            if (res.isSuccessful && res.statusCode == 200) {
              this.lastSubmitDate = res.data["lastSubmitDate"];
              this.lastThreeMonthSubmitCount = res.data["lastThreeMonthSubmitCount"];
            }
          });
        }, 500);
        console.log("getExhibitCatalogById");
        console.log({
          companyId: this.companyid,
          catalogId: id,
        });
        productService
          .getExhibitCatalogById({
            companyId: this.companyid,
            catalogId: id,
          })
          .then((res) => {
            console.log(res);
            if (res.isSuccessful) {
              //赋值
              this.indexDetails = res.data.sub_list;
              this.isActivate = true;
              //组装图片数据
              var Arr = {
                imageId: this.indexDetails.t_mf.rid,
                imageName: "",
                imageSrc: this.indexDetails.t_mf.fileName,
                modified: false,
                cdnLnk: this.indexDetails.t_mf.fileName,
              };
              this.imgArr.push(Arr);
              //pdf文件数据
              this.indexPdfDetails = {
                nameSC: "",
                pdfSC: "",
                nameTC: "",
                pdfTC: "",
                nameEN: "",
                pdfEN: "",
              };
              res.data.pdf_list.forEach((element) => {
                if (element.langId == 936) {
                  this.indexPdfDetails.nameSC = element.name;
                  this.indexPdfDetails.pdfSC = element.t_mf.fileName;
                  this.isPdfSC = element.t_mf.fileName ? true : false;
                } else if (element.langId == 950) {
                  this.indexPdfDetails.nameTC = element.name;
                  this.indexPdfDetails.pdfTC = element.t_mf.fileName;
                  this.isPdfTC = element.t_mf.fileName ? true : false;
                } else {
                  this.indexPdfDetails.nameEN = element.name;
                  this.indexPdfDetails.pdfEN = element.t_mf.fileName;
                  this.isPdfEN = element.t_mf.fileName ? true : false;
                }
              });
              this.indexName = this.indexDetails.name;
              this.lastUpdateDate = this.indexDetails.saveDate;
              this.isNew = false;
            }
          })
          .finally(() => {
            this.loading = false;
            setTimeout(() => {
              this.dirty = false;
            }, 500);
          });
        // this.$nextTick(() => {
        //     this.indexName = "Index " + id;
        //     this.isNew = false;
        // })
      } else {
        this.loading = false;
        this.indexName = "";
        this.isNew = true;
        this.indexDetails = {
          catalogId: 0,
          empCompanyId: 0,
          isLaunch: true,
          name: "",
          orderId: 0,
          t_mf: {},
        };
        this.indexPdfDetails = {};
        this.isPdfSC = false;
        this.isPdfTC = false;
        this.isPdfEN = false;
        setTimeout(() => {
          this.dirty = false;
        }, 500);
      }
    },
    closeIndexDetail: function () {
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToCancel"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((res) => {
        if (res.isConfirmed) {
          this.$router.replace("/productInfoCenter/default");
        }
      });
    },
    deleteIndexDetail: function () {
      this.$swal({
        text: this.$t("lbl_EMPBE_SureToDelete"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          var id = this.$route.params.id ? this.$route.params.id : this.IndexId;
          var parms = {
            companyId: this.companyid,
            catalogId: id,
          };
          //axios请求
          productService.deleteProdutCatalogDetail(parms).then((res) => {
            if (res.isSuccessful) {
              this.$swal({
                text: this.$t("lbl_EMPBE_DeleteSuccess"),
              }).then(() => {
                this.refreshParent();
                this.$router.replace("/productInfoCenter/default");
              });
              // this.refreshParent();
            }
          });
        }
      });
    },
    AppendQueryPdf(catalogPdf, str) {
      if (catalogPdf) {
        fileUploadService.AppendQuery(str, "PDF", [
          {
            Src: catalogPdf,
            modified: true,
            cdnLnk: "",
            FileName: catalogPdf.name,
          },
        ]);
      }
    },
    todoSubmit() {
      //[20231116][JWS] Check at least one pdf to submit
      if (!this.isPdfSC && !this.isPdfTC && !this.isPdfEN) {
        this.$swal({
          //Show Alert
          text: this.$t("lbl_EMPBE_CatalogCheckingMsg"),
          showCancelButton: false,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        })
        return;
      }

      this.$refs.observer.validate().then(async (res) => {
        if (res) {
          if (true) {
            this.IsSubmit = true;
            this.checkProductCalalogLaunch();
          } else {
            this.submitIndexDetail();
          }
        } else {
          for (const key of Object.keys(this.$refs.observer.fields)) {
            if (this.$refs.observer.fields[key].invalid) {
              var element = this.$refs.observer.refs[key].$el;
              let position = element.getBoundingClientRect();
              var top = position.top + 300;
              setTimeout(() => {
                element.scrollIntoView({ top: top, behavior: "smooth" });
              }, "300");
            }
          }
        }
      });
    },
    todoSave() {
      if (true) {
        this.IsSave = true;
        this.checkProductCalalogLaunch();
      } else {
        this.saveIndexDetail();
      }
    },
    async GetParam() {
      var id = this.$route.params.id ? this.$route.params.id : this.IndexId;
      var that = this;
      var emp_id = this.companyid;
      console.log(that.indexDetails);
      var tempExhibitCatalog = {
        EmpCompanyId: emp_id,
        IsLaunch: true,
        OrderId: 0,
        CatalogId: id > 0 ? id : null,
      };
      //封面处理
      this.$refs.imgIndexBanner.AppendUploadQuery();
      //PDF处理
      var catalogPdfSC = this.$refs.catalogPdfSC.files[0];
      var catalogPdfTC = this.$refs.catalogPdfTC.files[0];
      var catalogPdfEN = this.$refs.catalogPdfEN.files[0];
      this.isPdfSC = !catalogPdfSC && this.isPdfSC;
      this.isPdfTC = !catalogPdfTC && this.isPdfTC;
      this.isPdfEN = !catalogPdfEN && this.isPdfEN;
      that.AppendQueryPdf(catalogPdfSC, "catalogPdfSC");
      that.AppendQueryPdf(catalogPdfTC, "catalogPdfTC");
      that.AppendQueryPdf(catalogPdfEN, "catalogPdfEN");

      var Param = [];
      var ParamLang = [];
      var result = await fileUploadService.UploadToServer(this).then((res) => {
        console.log(res);
        that.files.forEach((file) => {
          var arr = res.filter((x) => x.refName == file.componentId);
          var _item = {
            EmpCompanyId: emp_id,
            UsageType: file.UsageType,
            LangId: file.LangId,
          };
          if (arr.length > 0 && arr[0].array.length > 0) {
            _item.FileName = arr[0].array[0].cdnLnk;
          } else {
            if (file.UsageType == "ExhibitCatalog_Pdf") {
              if (file.LangId == 936 && this.isPdfSC) {
                _item.FileName = this.indexPdfDetails.pdfSC;
              } else if (file.LangId == 950 && this.isPdfTC) {
                _item.FileName = this.indexPdfDetails.pdfTC;
              } else if (file.LangId == 1252 && this.isPdfEN) {
                _item.FileName = this.indexPdfDetails.pdfEN;
              } else {
                _item.FileName = "";
              }
            }
          }
          var itemlang = {
            LangId: file.LangId,
            Description: file.UsageType,
          };
          if (file.componentId == "imgIndexBanner") {
            itemlang.Name = that.indexDetails.name;
          }
          if (file.componentId == "catalogPdfTC") {
            itemlang.Name = that.indexPdfDetails.nameTC;
          }
          if (file.componentId == "catalogPdfSC") {
            itemlang.Name = that.indexPdfDetails.nameSC;
          }
          if (file.componentId == "catalogPdfEN") {
            itemlang.Name = that.indexPdfDetails.nameEN;
          }
          Param.push(_item);
          ParamLang.push(itemlang);
        });
        console.log(result);
        console.log(Param);
      });
      var parms = {
        TempExhibitCatalog: tempExhibitCatalog,
        Files: Param,
        FileLangs: ParamLang,
      };
      console.log("parms", parms);
      return parms;
    },
    async saveIndexDetail() {
      this.$swal({
        //Show Alert
        text: this.$t("lbl_EMPBE_AreYouSureToSave"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          var Params = await this.GetParam();
          productService
            .saveProdutCatalogDetail(Params)
            .then((res) => {
              console.log(res);
              if (res.isSuccessful) {
                this.$swal({
                  text: this.$t("lbl_EMPBE_SaveSuccess"),
                  type: "success",
                });
                if (this.$route.params.id != res.data) {
                  this.$router.push({
                    name: this.$router.currentRoute.name,
                    params: { id: res.data },
                  });
                  this.$parent.$parent.$parent.$parent.openSidebarAfterSave();
                } else {
                  this.initData();
                }
                this.refreshParent();
                // if (this.IsSubmit) {
                //   this.submitIndexDetail();
                // }
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
        //todo submit companyinfo
      });
    },
    async submitIndexDetail() {
      //validation
      this.$swal({
        text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          var Params = await this.GetParam();
          productService
            .submitProdutCatalogDetail(Params)
            .then((res) => {
              if (res.isSuccessful) {
                this.$swal({
                  text: this.$t("lbl_EMPBE_SubmitSuccess"),
                  type: "success",
                });
                if (this.$route.params.id != res.data) {
                  this.$router.push({
                    name: this.$router.currentRoute.name,
                    params: { id: res.data },
                  });
                  this.$parent.$parent.$parent.$parent.hideSidebarNavMenu();
                } else {
                  this.initData();
                  this.$parent.$parent.$parent.$parent.hideSidebarNavMenu();
                }
                this.refreshParent();
              } else {
                this.$swal({
                  text: this.$t("lbl_emp2_PopupFailedTitle"),
                  type: "success",
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    checkProductCalalogLaunch() {
      let that = this;
      var id = this.$route.params.id ? this.$route.params.id : this.IndexId;
      var otherInfo = this.$parent.$parent.$parent.$parent.getotherInfo();
      var launchCount = id > 0 ? otherInfo.directory_LaunchedCount : otherInfo.directory_LaunchedCount + 1
      if (launchCount > otherInfo.directory_TotalQty) {
        var message = that.$t("lbl_EMPBE_OverActivateCatalogAmount");
        that.alertMsg(message);
      } else {
        //保存和提交操作
        if (that.IsSave) {
          that.saveIndexDetail();
        }
        if (that.IsSubmit) {
          that.submitIndexDetail();
        }
      }

      // var result = productService
      //   .checkSysAccountPaymentInfo({
      //     CompanyId: this.companyid,
      //     type: "productcatalog",
      //     id: id,
      //     demodate: "",
      //   })
      //   .then((res) => {
      //     if (res.isSuccessful) {
      //       if (res.data) {
      //         let data = res.data;
      //         if (data.launchCount > data.payTotalQty) {
      //           var message = this.$t("lbl_EMPBE_OverActivateCatalogAmount");
      //           that.alertMsg(message);
      //           return false;
      //         } else {
      //           //保存和提交操作
      //           if (that.IsSave) {
      //             this.saveIndexDetail();
      //           }
      //           if (that.IsSubmit) {
      //             this.submitIndexDetail();
      //           }
      //         }
      //       } else {
      //         //保存和提交操作
      //         if (that.IsSave) {
      //           this.saveIndexDetail();
      //         }
      //         if (that.IsSubmit) {
      //           this.submitIndexDetail();
      //         }
      //       }
      //     }
      //   });
      // return result;
    },
    //刷新父级
    refreshParent() {
      this.$parent.$parent.$parent.$parent.refresh();
    },
    alertMsg(message) {
      this.$swal({
        text: message,
        showCancelButton: false,
      });
    },
    openPdf(){
      var that = this;
      var test = this.$refs.catalogPdfSC.files[0];
    }
  },
};
</script>
<style>
.file-pdf {
  border-radius: 5px;
  padding: 10px;
  background-color: #f6f7fb;
}

.file-top {
  height: 100px;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 5px;
  font-size: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-bottom {
  padding-top: 10px;
  height: 45px;
}
</style>
